import {
  SettingOutlined,
  UserOutlined,
  DashboardOutlined,
  ToolOutlined,
  UnorderedListOutlined,
  StockOutlined,
  CloudUploadOutlined,
} from '@ant-design/icons';

const iconList = {
  SettingOutlined: <SettingOutlined />,
  UserOutlined: <UserOutlined />,
  DashboardOutlined: <DashboardOutlined />,
  ToolOutlined: <ToolOutlined />,
  UnorderedListOutlined: <UnorderedListOutlined />,
  StockOutlined: <StockOutlined />,
  CloudUploadOutlined: <CloudUploadOutlined />,
};

export default iconList;
